<template>
    <v-tooltip
        right
    >
        <template
            v-slot:activator="{ on, attrs }"
        >
            <v-chip
                :color="statusColor"
                v-on="on"
                v-bind="attrs"
                dark
            >
                <v-icon>
                    {{ statusIcon }}
                </v-icon>
            </v-chip>
        </template>
        <div
            v-if="missingCategories.length > 0"
        >
            <span>
                {{ $t('rula.label.missingCategories') }}
            </span>
            <ul>
                <li
                    v-for="(category, key) in missingCategories"
                    :key="key"
                >
                    {{ $t(`rula.category.${category}`) }}
                </li>
            </ul>
        </div>
        <div
            v-else
        >
            {{ $t('rula.label.complete') }}
        </div>
    </v-tooltip>
</template>

<script>
import {getMissingCategories, getRulaCategories} from "@/utils/rula";

export default {
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        missingCategories() {
            return getMissingCategories(this.item._meta);
        },
        statusColor() {
            const missing = this.missingCategories;

            if(
                missing.length === 0 ||
                (
                    this.item._meta &&
                    this.item._meta.rulaReleased
                )
            ) {
                return 'green';
            }

            if(missing.length < getRulaCategories().length) {
                return 'orange';
            }

            return 'red';
        },
        statusIcon() {
            const missing = this.missingCategories;
            if(
                missing.length === 0 ||
                (
                    this.item._meta &&
                    this.item._meta.rulaReleased
                )
            ) {
                return 'mdi-check-all';
            }
            if(missing.length < getRulaCategories().length) {
                return 'mdi-check';
            }

            return 'mdi-close';
        },
    }
}
</script>
